import { ApolloClient, defaultDataIdFromObject, InMemoryCache } from "@apollo/client";
import { ApolloProvider } from "@apollo/react-hooks";

const cache = new InMemoryCache();

const apollo = new ApolloClient({
  uri: process.env.REACT_APP_API_BASE_URL,
  cache,
});

export default function GlobalServicesProvider({ children }) {

  return <ApolloProvider client={apollo}>{children}</ApolloProvider>;
}

export { cache, apollo };
